import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSubSection } from '../../../../../redux/actions';
import VideoPlayer from '../../../../Shared/VideoPlayer/VideoPlayer';
import './Intro.css';
import { SUB_SECTION_VIDEO } from '../../../../../content';
import BackButton from '../../../../Shared/BackButton/BackButton';

class Intro extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
  }

  handleClick() {
    this.props.setSubSection('');
  }

  handleEnd() {
    this.props.setSubSection('');
  }

  render() {
    return (
      <div id="intro-section">
        <VideoPlayer
          source={SUB_SECTION_VIDEO.INTRO}
          onEnded={this.handleEnd}
        />
        <BackButton onClick={this.handleClick} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setSubSection: sectionId => dispatch(setSubSection(sectionId)),
});

export default connect(null, mapDispatchToProps)(Intro);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/Intro/Intro.js